import type { StoredReport } from '@wrp/shared';

export interface Point {
  x: number;
  y: number;
}

export function formatTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleTimeString(undefined, { hour12: false });
}

export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, { hour12: false });
}

export function formatMetres(value: number | null | undefined, digits = 2): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return `${value.toFixed(digits)} m`;
}

export function formatXY(p: { x: number; y: number } | null | undefined, digits = 2): string {
  if (!p) return '—';
  return `${p.x.toFixed(digits)}, ${p.y.toFixed(digits)}`;
}

/** Strongest (max) RSSI in a report; reports are sorted strongest-first by the backend. */
export function strongestRssi(report: StoredReport): number | null {
  let best: number | null = null;
  for (const ap of report.aps) {
    const rssi = ap.signal_strength;
    if (typeof rssi !== 'number') continue;
    if (best === null || rssi > best) best = rssi;
  }
  return best;
}

/** Maps a dBm value to a 0..1 strength ratio for the RSSI bar. */
export function rssiRatio(dbm: number): number {
  const clamped = Math.min(-30, Math.max(-100, dbm));
  return (clamped + 100) / 70;
}

export function rssiClass(dbm: number): 'good' | 'fair' | 'weak' {
  if (dbm >= -60) return 'good';
  if (dbm >= -75) return 'fair';
  return 'weak';
}

export function shortId(id: string): string {
  return id.length <= 8 ? id : `${id.slice(0, 8)}…`;
}
